import { QuestionType2UIConfig } from "../../../../../components/ui/question-type2-ui";
import { GeneralQuestionUIConfig, GeneralQuestionUIConfigOption } from "../../../../../cvp-webgames-core/Components/ui/react/core-general-question-ui";
import BaseScenarioPart from "../../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { VideoSegmentItem, SingleVideoSegmentItem } from "../../../../../cvp-webgames-core/VideoSegment/VideoSegmentItem";
import { ScoringType } from "../../../../../misc/tools";
import { GameBaseScenario } from "../../../../GameBaseScenario";
import Scenario8RmeTempHum, { scenario8RmeTempHumAudioCaching, scenario8RmeTempHumVideoSegments } from "../../../scenario8-rme-temp-hum";
import { RmeTempHumComponentsStep1ComponentPart1Config, RmeTempHumComponentsStep1ComponentMainConfig } from "../rme-temp-hum-components-step1";

export default class RmeTempHumComponentsStep1Part1 extends BaseScenarioPart<GameBaseScenario> {
	private stepName = 'Step 2'
	private get config(): RmeTempHumComponentsStep1ComponentPart1Config {
		return this.mainConfig.part1Config;
	}
	constructor(scenario: GameBaseScenario, private onDone: () => void, private id: string, private mainConfig: RmeTempHumComponentsStep1ComponentMainConfig) {
		super(scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	public start() {
		this.section1();
	}

	public section1() {
		const context = this;
        this.mainConfig.scenario.setAreaForCurrentScenario(6);
		this.mainConfig.scenario.uiWrapper.displayMixedMediaUI({
			title: this.mainConfig.scenario.props.name,
			subtitle: this.stepName,
			htmlData: `
			<p class="default-text add-pad">For the substitution test, you approach other employees and inquire as to whether they would do the same 
			thing in similar circumstances.<br/><br/>
			Nurse #1: Well, I think the charge nurse is supposed to check that for the clean 
			utility room, but I’m not really sure.<br/><br/>
			Nurse #2: The temperature and humidity Protocol? Ummm, I don’t really know much, 
			other than it’s the SPS’s responsibility to check it.<br/><br/>
			Nurse #3: No, I don’t think I’ve ever had that happen. Doesn’t SPS get an 
			automatic alert or something?</p>
			`,
			okButton: 'Continue',
			talkingVideoSrc: scenario8RmeTempHumVideoSegments.getItemByKey('MixedMedia').src,
			talkingVideoChapterId: scenario8RmeTempHumVideoSegments.getItemByKey('MixedMedia').chapterIds[0],
			onContinueClicked: () => {
				context.section2();
			}
		})
	}

	public section2() {
		const context = this;
		this.mainConfig.scenario.uiWrapper.displayQuestonType2UI({
			audioUrl: scenario8RmeTempHumAudioCaching.getItemByKey(scenario8RmeTempHumAudioCaching.audioKeys.question3).src,
			title: this.mainConfig.scenario.props.name,
			subtitle: (this.stepName + ' - Question 1'),
			isYesCorrect: true,
			correctFeedback: `
				<p class="default-text">Correct. When asked, very few staff understood temperature and 
				humidity and others were unsure. None of the staff discussed the effects of high 
				workload creating pressure to sometimes take short cuts.</p>
			`,
			wrongFeedback: `
				<p class="default-text">This is not the best option. The other nurses stated that 
				they would not do the same thing in similar circumstances.</p>
			`,
			question: 'Given the information received from staff interviews, is it reasonable to conclude that a systems or cultural issue exists, and other employees in that work area would behave the same way in a similar situation?',
			onSubmitClicked: (isCorrect: boolean, feedback: string, selectedTitle: string, parentQuestion: QuestionType2UIConfig) => {
				const mentorInfo = scenario8RmeTempHumVideoSegments.getItemByKey('Feedback');
				context.scenario.onChoiceSubmittedQuestionType2(isCorrect, feedback, selectedTitle, (this.stepName + ' - Question 1 '), parentQuestion, () => {
					context.section3();
				}, () => {
					context.section3();
				}, undefined, undefined, undefined, mentorInfo.src, mentorInfo.chapterIds[6], mentorInfo.chapterIds[7]);
			}
		}, 2);
	}

	public section3() {
		const context = this;
		this.mainConfig.scenario.uiWrapper.displayQuestonType1UI({
			audioUrl: scenario8RmeTempHumAudioCaching.getItemByKey(scenario8RmeTempHumAudioCaching.audioKeys.question4).src,
			title: this.mainConfig.scenario.props.name,
			subtitle: (this.stepName + ' - Question 2'),
			questionTitle: 'Based on the substitution test, the accountability for this action…',
			options: [
				{
					title: 'Lies completely with the employee.',
					description: 'Select and submit an option.',
					feedbackHtml: `
						<p class="default-text">This is not the best option. The substitution test demonstrates that 
						other employees would make a similar choice and there are system or cultural issues identified.</p>
					`,
					isCorrect: false,
					score: ScoringType.bad
				},
				{
					title: 'Is shared between the employee and organizational leadership.',
					description: 'Select and submit an option.',
					feedbackHtml: `
						<p class="default-text">Correct. The substitution test demonstrates that other employees would 
						make a similar choice and there are system or cultural issues identified.</p>
					`,
					isCorrect: true,
					score: ScoringType.good
				},
				{
					title: 'Lies solely with the leadership.',
					description: 'Select and submit an option.',
					feedbackHtml: `
						<p class="default-text">This is not the best option. The substitution test demonstrates that 
						there are system or cultural issues identified but also accountability for the employee’s actions.</p>
					`,
					isCorrect: false,
					score: ScoringType.bad
				}
			],
			
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				const mentorInfo = scenario8RmeTempHumVideoSegments.getItemByKey('Feedback');
				context.scenario.onChoiceSubmittedQuestionType1(selectedChoices[0], (this.stepName + ' - Question 2 '), parentQuestionConfig, () => {
					this.onDone();
				}, () => {
					this.onDone();
				}, undefined, undefined, undefined, mentorInfo.src, mentorInfo.chapterIds[8], mentorInfo.chapterIds[9], mentorInfo.chapterIds[10], 'Lies completely with the employee.');
			}
		},3);
	}
}